import { render } from "./GiftForm.vue?vue&type=template&id=9122eef8"
import script from "./GiftForm.vue?vue&type=script&lang=js"
export * from "./GiftForm.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__